// import { MoveClientPage } from "components/ClientBank";

import { AuthenticatedLayout } from "../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { MoveClients } from "../../../components/Client/MoveClients";

export const MoveClientPage = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Move Clients"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				// { text: "Move Clients", navigateTo: "/clients/move-clients" },
			]}
			mainContents={<MoveClients />}
		/>
	);
};
